import request from "../utils/request";

// ========== 后台用户管理 ==========
export function getSysUserList(data) {
  return request({ url: "/sysapi/sysuser/list", data });
}
export function addSysUser(data) {
  return request({ url: "/sysapi/sysuser/add", data });
}
export function updateSysUser(data) {
  return request({ url: "/sysapi/sysuser/update", data });
}
export function deleteSysUser(data) {
  return request({ url: "/sysapi/sysuser/delete", data });
}
export function resetSysUserPwd(data) {
  return request({ url: "/sysapi/sysuser/resetpwd", data });
}

// ========== 角色管理 ==========
export function getRoleList(data) {
  return request({ url: "/sysapi/role/list", data });
}
export function addRole(data) {
  return request({ url: "/sysapi/role/add", data });
}
export function updateRole(data) {
  return request({ url: "/sysapi/role/update", data });
}
export function deleteRole(data) {
  return request({ url: "/sysapi/role/delete", data });
}
export function getRoleMenus(data) {
  return request({ url: "/sysapi/role/menus", data });
}
export function saveRoleMenus(data) {
  return request({ url: "/sysapi/role/savemenus", data });
}

// ========== 菜单管理 ==========
export function getMenuList(data) {
  return request({ url: "/sysapi/menu/list", data });
}
export function getMyMenus(data) {
  return request({ url: "/sysapi/menu/mymenus", data });
}
export function addMenu(data) {
  return request({ url: "/sysapi/menu/add", data });
}
export function updateMenu(data) {
  return request({ url: "/sysapi/menu/update", data });
}
export function deleteMenu(data) {
  return request({ url: "/sysapi/menu/delete", data });
}
